import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { CmCoreModule } from '@ats/cm/core';
import { CmTableModule } from '@ats/cm/table';
import { CmUiModule } from '@ats/cm/ui';
import { AtsIconsModule } from '@ats/icons';
import { AtsUiModule } from '@ats/ui';
import { AtsUtilityModule } from '@ats/utility';
import { CmMiniButtonDirective } from '@cm/shared/ui/button';
import { IpClientRequiredSelectorComponent } from './components/client-required-selector/client-required-selector.component';
import { IpClientToolbarComponent } from './components/client-toolbar/client-toolbar.component';
import { IpConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { IpNavComponent } from './components/nav/nav.component';
import { IpPagedHeaderComponent } from './components/paged-header/paged-header.component';
import { IpTreeBranchComponent } from './components/tree-branch/tree-branch.component';
import { IpViewComponent } from './components/view/view.component';

const declarations = [
	IpClientRequiredSelectorComponent,
	IpClientToolbarComponent,
	IpConfirmationDialogComponent,
	IpNavComponent,
	IpPagedHeaderComponent,
	IpTreeBranchComponent,
	IpViewComponent,
];

const imports = [
	CmCoreModule,
	CmUiModule,
	CmTableModule,
	AtsIconsModule,
	AtsUiModule,
	AtsUtilityModule,
	FormsModule,
	CmMiniButtonDirective,
	MatTabsModule,
];

const exports = [...imports, ...declarations];

@NgModule({
	declarations,
	imports: [imports, MatIconModule],
	exports,
})
export class IpUiModule {}
